const style = {
	setFont: {
		fontFamily: 'Poppins',
		fontWeight: 500,
		fontSize: 36,
	},
	parentContainer: {
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: '14px'
	}
};

export default style;
